import { activeProvidersMock } from "./mock";
const API_URL = process.env.REACT_APP_API_URL;
const UPDATE_OFFER = API_URL + "/trade/UpdateClientOffer";

export async function updateOffer(offerId: string) {
  try {
    const response = await fetch(UPDATE_OFFER, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: offerId, status: 7 }),
    });
    const data = await response.json();
  } catch (err) {}
}

export async function refreshpayment(offerId: string): Promise<boolean> {
  try {
    const REFRESH_OFFER = API_URL + "/trade/RefreshOfferCard/" + offerId;
    const response = await fetch(REFRESH_OFFER, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    if (data.isUpdated) {
      window.location.reload();
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
}

export async function cancelPayment(offerId: string) {
  try {
    const response = await fetch(UPDATE_OFFER, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: offerId, status: 10 }),
    });
    const data = await response.json();
  } catch (err) {}
}

// Эндпоинты RESTWrapper (/api/TradeVerification/*) отвечают HTTP 200 даже на отказ:
// признак результата лежит в теле. Поэтому одного response.ok мало — без разбора тела
// отклонённая загрузка выглядела как принятая, и файл молча терялся.
// Регистр поля не фиксирован: контроллер отдаёт анонимный объект { Success, Message },
// а сериализатор по умолчанию (AddControllers без PropertyNamingPolicy) переводит его
// в camelCase. Читаем оба варианта, чтобы фикс не отключился от настройки сериализации.
// К /trade/* (gRPC-транскод) это НЕ применять — там свой контракт.
async function readVerificationResult(
  response: Response
): Promise<{ success: boolean; message?: string }> {
  if (!response.ok) {
    return { success: false };
  }

  // Тело читаем терпимо: пустой/не-JSON ответ при 200 считаем успехом, как было раньше.
  const body = await response.json().catch(() => null);
  const flag = body?.success ?? body?.Success;

  if (flag === false) {
    const message = body?.message ?? body?.Message;
    return {
      success: false,
      message: typeof message === "string" ? message : undefined,
    };
  }

  return { success: true };
}

export async function sendVerification(
  file: File | null,
  offerId: string,
  amountFiat: string,
  cardNumber: string
): Promise<{
  success: boolean;
}> {
  try {
    const VERIF_OFFER = API_URL + "/api/TradeVerification/UploadVerification";

    const formdata = new FormData();
    file && formdata.append("File", file);
    formdata.append("offerId", offerId);
    formdata.append("amountFiat", amountFiat);
    formdata.append("cardNumber", cardNumber);

    const response = await fetch(VERIF_OFFER, {
      method: "POST",
      body: formdata,
    });

    // Тот же контракт, что и у UploadCardPhoto: 200 + Success=false на отказ.
    // Message здесь может быть объектом ModelState — хелпер отдаёт только строки.
    const { success } = await readVerificationResult(response);
    return { success };
  } catch (err) {
    return {
      success: false,
    };
  }
}

// Загрузка фото карты (верификация принадлежности карты, не чек).
// Отдельный endpoint, чтобы не дёргать cascade/dispute/PDF-ветки UploadVerification.
// Поддерживает несколько файлов; cardType — plastic/virtual/other из ТЗ.
export async function sendCardPhoto(
  files: File[],
  offerId: string,
  cardType: string
): Promise<{ success: boolean; message?: string }> {
  try {
    const UPLOAD_CARD_PHOTO =
      API_URL + "/api/TradeVerification/UploadCardPhoto";

    const formdata = new FormData();
    files.forEach((file) => formdata.append("Files", file));
    formdata.append("offerId", offerId);
    formdata.append("cardType", cardType);

    const response = await fetch(UPLOAD_CARD_PHOTO, {
      method: "POST",
      body: formdata,
    });

    return await readVerificationResult(response);
  } catch (err) {
    return { success: false };
  }
}

interface IBankProviderResponse {
  activeProviders: {
    providerCode: string;
    paymentMethods: ["Sbp", "BankAccount", "Card"];
    providerName: string;
  }[];
}

export async function getOfferProviders(
  offerId: string
): Promise<IBankProviderResponse | null> {
  try {
    const response = await fetch(
      API_URL + "/trade/GetActiveProvidersByOffer/" + offerId,
      {
        method: "GET",
      }
    );
    // return activeProvidersMock as any
    const data = await response.json();
    return data;
  } catch (err) {
    return null;
  }
}

export async function updatePaymentMethod(
  offerId: string,
  paymentMethod: number,
  providerCode: string
) {
  try {
    const response = await fetch(API_URL + "/trade/updatePaymentMethodOffer", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ offerId, paymentMethod, providerCode }),
    });
    const data = await response.json();
  } catch (err) {}
}

export async function sendFingerPrint(print: object) {
  try {
    const response = await fetch(
      API_URL + "/paymentFraud/updateFingerprintInfoV2",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(print),
      }
    );
    return true;
  } catch (err) {
    return false;
  }
}

interface IAmountRangesResponse {
  amountRanges: string[];
}

export async function getAmountRanges(offerId: string): Promise<string[]> {
  try {
    const REFRESH_OFFER =
      API_URL + "/trade/getAvailableOfferAmountRanges?offerId=" + offerId;
    const response = await fetch(REFRESH_OFFER, {
      method: "GET",
    });
    if (response.ok) {
      const data = (await response.json()) as IAmountRangesResponse;
      return data.amountRanges;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
}

export async function updateOfferAmount(
  offerId: string,
  amountFiat: string
): Promise<{
  success: boolean;
}> {
  try {
    const response = await fetch(API_URL + "/trade/updateBuyOfferAmount", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ offerId, amountFiat }),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      return {
        success: false,
      };
    }
  } catch (err) {
    return {
      success: false,
    };
  }
}

export async function updateOfferVisitorCardNum(
  offerId: string,
  cardNumber: string
): Promise<{
  success: boolean;
  message: string;
}> {
  try {
    const response = await fetch(
      API_URL + "/trade/updateOfferVisitorCardNumber",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ offerId, cardNumber }),
      }
    );
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      return {
        success: false,
        message: "",
      };
    }
  } catch (err) {
    return {
      success: false,
      message: "",
    };
  }
}
